var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLock = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.99984 2.66668C7.4694 2.66668 6.9607 2.87739 6.58562 3.25246C6.21055 3.62754 5.99984 4.13624 5.99984 4.66668V6.66668H9.99984V4.66668C9.99984 4.13624 9.78912 3.62754 9.41405 3.25246C9.03898 2.87739 8.53027 2.66668 7.99984 2.66668ZM11.3332 6.66668V4.66668C11.3332 3.78262 10.982 2.93478 10.3569 2.30965C9.73174 1.68453 8.88389 1.33334 7.99984 1.33334C7.11578 1.33334 6.26794 1.68453 5.64281 2.30965C5.01769 2.93478 4.6665 3.78262 4.6665 4.66668V6.66668C3.56193 6.66668 2.6665 7.56211 2.6665 8.66668V12.6667C2.6665 13.7712 3.56193 14.6667 4.6665 14.6667H11.3332C12.4377 14.6667 13.3332 13.7712 13.3332 12.6667V8.66668C13.3332 7.56211 12.4377 6.66668 11.3332 6.66668ZM4.6665 8.00001C4.29831 8.00001 3.99984 8.29849 3.99984 8.66668V12.6667C3.99984 13.0349 4.29831 13.3333 4.6665 13.3333H11.3332C11.7014 13.3333 11.9998 13.0349 11.9998 12.6667V8.66668C11.9998 8.29849 11.7014 8.00001 11.3332 8.00001H4.6665ZM6.6665 10.6667C6.6665 9.9303 7.26346 9.33334 7.99984 9.33334C8.73622 9.33334 9.33317 9.9303 9.33317 10.6667C9.33317 11.4031 8.73622 12 7.99984 12C7.26346 12 6.6665 11.4031 6.6665 10.6667Z",
  fill: "#ADB5BD"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "2f29ba1890ff17b4e981fee17cbf0e37.svg";